import {Header} from "@/components/Header";
import {useEffect} from "react";
import {SquareDharmikLayout} from "@/pages/SqaureDharmikLayout";

export const Mantropchar = () => {
	const Dharmikdata = [
		{
			img: "/other_imgs/thumbnail-dharmik-ambajogai.png",
			title: "योगेश्वरी देवी, अंबाजोगाई",
			href: "/yogeshwari-devi-mantropchar",
		},
		{
			img: "/other_imgs/thumbnail-dharmik-vyadeshwar.png",
			title: "व्याडेश्वर, गुहागर",
			href: "",
		},
	];

	useEffect(() => {
		// Scroll to top when the page is rendered
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			<div className="w-full  flex flex-col items-center justify-center">
				<Header/>

				<img
					src="/other_imgs/banner-dharmik-mantropchar-inside.jpg"
					alt="Information Banner"
					className="w-full  shadow-lg"
				/>
			</div>
			<div className="flex flex-wrap gap-4 items-center justify-center mt-10">
				{Dharmikdata.map((data, i) => (
					<SquareDharmikLayout key={i} data={data}/>
				))}
			</div>
		</>
	);
};
